/* jscpd:ignore-start */
import { fetchFromVolatileServer } from "../fetchFromVolatileServer";
import { getServiceURL } from "../url";

export async function confirmPasswordReset(
  password: string,
  token: string,
  locale?: string,
) {
  const url = `${getServiceURL(locale)}/passwordreset/confirmation?token=`;
  return fetchFromVolatileServer(`${url}${token}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({ password: password }),
  })
    .then((res) => {
      if (!res.ok) {
        console.error("Response not ok for", url, res.status);
        throw new Error("Response not ok");
      }
      return res.json();
    })
    .catch((err) => {
      console.error(err);
      return null;
    });
}

export async function passwordReset(email: string, locale?: string) {
  return fetchFromVolatileServer(`${getServiceURL(locale)}/passwordreset`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({ email: email, locale: locale }),
  })
    .then((res) => {
      if (!res.ok) {
        console.error(res.status);
        throw new Error("Response not ok");
      }
      return res.json();
    })
    .catch((err) => {
      console.error(err);
      return null;
    });
}
/* jscpd:ignore-end */
